import { AGENT_HUB_ADMIN_BASE_PATH } from '@lumapps/agent-hub/constants';
import type { AskAiSource } from '@lumapps/ask-ai-sources/types';
import { Route, AppId, createEntityManagementRoutes } from '@lumapps/router';

const { baseRoute, createRoute, editRoute, getEditRoute } = createEntityManagementRoutes({
    slug: `${AGENT_HUB_ADMIN_BASE_PATH}/sources`,
    id: 'agent-hub-sources',
    appId: AppId.backOffice,
});

export const agentHubEditSource = (sourceId: AskAiSource['id']): Route => getEditRoute(sourceId);

export {
    baseRoute as agentHubBaseSourcesAdminRoute,
    editRoute as agentHubEditSourceRoute,
    createRoute as agentHubCreateSourceRoute,
};

/** Parameters for the Agent hub source form page (edition) */
export interface AgentHubSourceFormParams {
    id: string;
}
